import {
  Field,
  Flex,
  Separator,
  SimpleGrid,
  Text,
  Textarea,
} from "@chakra-ui/react";
import TableList from "components/TableList";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { ToggleSwitch } from "components/ToggleSwitch";
import RadioInput from "components/RadioInput";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import ButtonComp from "components/Button";
import { useLocation, useNavigate } from "react-router-dom";
import constant from "constant";
import { CheckboxComp } from "components/CheckboxComp";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import Layout from "components/Layout";
import utils from "utils";

const fs = "sm";

// const items = [
//   {
//     id: 1,
//     Attached: "Attached",
//     "Group Name": "Group Name",
//   },
// ];

function UserAdd() {
  const [isLoading, setIsLoading] = useState(false);

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [address1, setAddress1] = useState();
  const [address2, setAddress2] = useState();
  const [county, setCounty] = useState();
  const [town, setTown] = useState();
  const [postcode, setPostcode] = useState();
  const [country, setCountry] = useState();
  const [active, setActive] = useState();
  const [hide, setHide] = useState();
  const [firstname, setFirstname] = useState();
  const [lastname, setLastname] = useState();
  // const [usertype, setUsertype] = useState();
  const [companyname, setCompanyname] = useState();
  const [address3, setAddress3] = useState();
  const [datejoined, setDatejoined] = useState();
  const [phonelandline, setPhonelandline] = useState();
  const [phonemobile, setPhonemobile] = useState();
  const [openingbalance, setOpeningbalance] = useState();
  const [refundafter, setRefundafter] = useState();
  const [sendagreementemail, setSendagreementemail] = useState();
  const [usernotes, setUsernotes] = useState();
  const [appcode, setAppcode] = useState();
  const [usecustomlogo, setUsecustomlogo] = useState();
  const [banksortcode, setBanksortcode] = useState();
  const [bankaccountnumber, setBankaccountnumber] = useState();
  const [pricingall, setPricingall] = useState();

  const [isNewAdmin, setIsNewAdmin] = useState();

  // AU Admin Charge
  const [adminchargeDD, setAdminchargeDD] = useState();
  const [adminchargeItem, setAdminchargeItem] = useState();
  const [adminChargeAmount, setAdminChargeAmount] = useState();
  const [adminChargePer, setAdminChargePer] = useState();

  // Associated Groups
  // const [assGroupsDD, setAssGroupsDD] = useState();
  // const [assGroups, setAssGroups] = useState();

  const [groupassociationList, setGroupassociationList] = useState([]);
  const [groupassociationSelc, setGroupassociationSelc] = useState();

  // g list
  // const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();

  // Default Commission Rule
  // const [defCommissionRuleDD, setDefCommissionRuleDD] = useState();
  // const [defCommissionRule, setDefCommissionRule] = useState();

  const [defaultCommRuleDD, setDefaultCommRuleDD] = useState();
  const [defaultCommRuleItem, setDefaultCommRuleItem] = useState();

  const [defaultCommRulePaidDD, setDefaultCommRulePaidDD] = useState();
  const [defaultCommRulePaidItem, setDefaultCommRulePaidItem] = useState();

  const [defaultCommRuleAmount, setDefaultCommRuleAmount] = useState();
  const [defaultCommRulePer, setDefaultCommRulePer] = useState();

  // user type permission
  const [permissionDD, setPermissionDD] = useState();
  const [permissionSelc, setPermissionSelc] = useState();

  const [permissionSt, setPermissionSt] = useState({});

  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();
  const location = useLocation();

  const action = location.state?.action;
  const itemData = location.state?.data;

  const onSubmit = async () => {
    let password3 = password;
    if (typeof password3 !== "string" || password3.trim() === "") {
      toaster.create({
        title: "please enter password",
        type: "error",
      });
      return;
    }

    const pl2 = {
      userid: itemData?.userid,

      username: username || "",
      password: itemData.password === password ? "" : password,
      email: email || "",
      address1: address1 || "",
      address2: address2 || "",
      address3: address3 || "",
      county: county || "",
      town: town || "",
      postcode: postcode || "",
      country: country || "",
      active: active,
      hide: hide,
      permissionid: permissionSelc?.permissionid || "",
      firstname: firstname || "",
      lastname: lastname || "",
      usertype: isNewAdmin ? 1 : 2, //permissionSelc?.permissionid || "",
      dealerid: -1, // dealerid || "",
      companyname: companyname || "",

      // vatrule: defaultCommRuleItem?.id || "",
      // vatamount: defaultCommRuleAmount || "",
      // vatpercentage: defaultCommRulePer || "",

      datejoined: datejoined ? utils.dateToDateInput(datejoined) : "",

      admincosttype: adminchargeItem?.id || "",
      admincostcent: adminChargePer || "",
      admincostamt: adminChargeAmount || "",

      phonelandline: phonelandline || "",
      phonemobile: phonemobile || "",
      openingbalance: openingbalance || "",
      refundafter: refundafter || "",

      commissiontype: defaultCommRuleItem?.id || "",
      commissioncent: defaultCommRulePer || "",
      commissionamt: defaultCommRuleAmount || "",
      commissionpaid: defaultCommRulePaidItem?.id || "",

      sendagreementemail: sendagreementemail || "",
      usernotes: usernotes || "",
      appcode: appcode || "",
      usecustomlogo: usecustomlogo || "",
      banksortcode: banksortcode || "",
      bankaccountnumber: bankaccountnumber || "",
      pricingall: pricingall || false,
    };

    pl2.groupassociation_data = [];

    const groupassociationList2 = JSON.parse(
      JSON.stringify(groupassociationList)
    );
    console.log("onSubmit groupassociationList2", groupassociationList2);
    if (groupassociationList2 && groupassociationList2[0]) {
      groupassociationList2.forEach((a) => {
        if (a?.Attached?.label === "Attach") {
          pl2.groupassociation_data.push(a?.data?.groupid);
        }
      });
    }

    console.log("onSubmit pl2", pl2);
    let res;
    setIsLoading(true);
    if (itemData?.userid) {
      res = await api.updateUser(pl2);
    } else {
      res = await api.addUser(pl2);
    }
    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/manageusers", {
        state: {},
      });
    }
  };

  const onChangeIsNewAdmin = (v) => {
    setIsNewAdmin(v);
    getPermissionDD();
  };

  const onChangePermissionDD = (data) => {
    // if (
    //   !permissionSt.perm_account_change_usertype &&
    //   data?.action === "byuser"
    // ) {
    //   toaster.create({
    //     title: "no permission",
    //     type: "error",
    //   });
    //   return;
    // }
    setPermissionDD(data?.list ? [...data.list] : []);
    setPermissionSelc(data?.item?.data);
  };

  const getPermissionDD = async (data) => {
    let index;
    let list;
    let item;
    setIsLoading(true);

    const res = await api.getPermission({ action: "getuserrole" });
    setIsLoading(false);
    if (res?.status === 200) {
      console.log("getPermission = ", res?.data);
      if (res?.data && res?.data[0]?.permissionid) {
        list = res.data.map((a, inx) => ({
          key: `permission-dd${inx}`,
          value: `${a?.permissionname}-${inx}`,
          label: `${a?.permissionname}`,
          data: a,
        }));
      }
    } else if (res?.status === 403) {
    } else {
      toaster.create({
        title:
          res?.response?.data?.message || res?.data?.message || res?.message,
        type: "error",
      });
    }

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.permissionid === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangePermissionDD({
      index,
      list,
      item,
    });
  };

  const onChangeDefaultCommRulePaidDD = (data) => {
    setDefaultCommRulePaidDD(data?.list ? [...data.list] : []);
    setDefaultCommRulePaidItem(data?.item?.data);
  };

  const getDefaultCommRulePaidDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.defaultCommRulePaidDD?.map((a, inx) => ({
      key: `default-comm-rule-paid${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeDefaultCommRulePaidDD({
      index,
      list,
      item,
    });
  };

  const onChangeDefaultCommRuleDD = (data) => {
    setDefaultCommRuleDD(data?.list ? [...data.list] : []);
    setDefaultCommRuleItem(data?.item?.data);
  };

  const getDefaultCommRuleDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.defaultCommRuleDD?.map((a, inx) => ({
      key: `default-comm-rule-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeDefaultCommRuleDD({
      index,
      list,
      item,
    });
  };

  const onAssGroAll = () => {
    const list2 = JSON.parse(JSON.stringify(groupassociationList || []));
    if (list2 && list2[0]?.Attached) {
      setGroupassociationList(
        list2.map((a) => {
          a.Attached = {
            label: "Attach",
            cellStyle: {
              color: "tex",
              fontWeight: "bold",
            },
          };

          return a;
        })
      );
    }
  };

  const onAssGroNon = () => {
    const list2 = JSON.parse(JSON.stringify(groupassociationList || []));
    if (list2 && list2[0]?.Attached) {
      setGroupassociationList(
        list2.map((a) => {
          a.Attached = {
            label: " ",
            cellStyle: {
              color: "tex",
              fontWeight: "bold",
            },
          };
          return a;
        })
      );
    }
  };

  const onGroupassociationSelc = (data) => {
    if (!permissionSt.perm_group_allocate && data?.action === "byuser") {
      toaster.create({
        title: "no permission",
        type: "error",
      });
      return;
    }
    setGroupassociationSelc(data);

    const list2 = JSON.parse(JSON.stringify(groupassociationList || []));
    if (list2 && list2[0] && list2[data?.index]?.Attached) {
      list2[data?.index].Attached = {
        label: list2[data?.index]?.Attached?.label === "Attach" ? "" : "Attach",
        cellStyle: {
          color: "text",
          fontWeight: "bold",
        },
      };
      setGroupassociationList([...list2]);
    }
  };

  const getGroupassociationList = async (data) => {
    // let index;
    let list = [];
    // let item;

    setIsLoading(true);
    const res = await api.getUsersGroupassociation({
      userid: itemData?.userid,
    });
    setIsLoading(false);
    if (res?.status === 200) {
      console.log(" getUsersGroupassociation = ", res?.data);
      if (res?.data?.available && res?.data?.available[0]?.groupid) {
        res.data.available.forEach((a, index) => {
          list.push({
            id: `users-gp-available-${index}`,
            // value: `${a.companyname}-${index}`,
            Attached: {
              label: " ", //itemData?.groupid === a?.userid ? "Attach" : " ",
              cellStyle: {
                color: "text",
                fontWeight: "bold",
                maxWidth: "3rem",
              },
            },
            label: a.groupname,
            data: a,
          });
        });
      }

      if (res?.data?.in && res?.data?.in[0]?.groupname) {
        res.data.in.forEach((a, index) => {
          list.push({
            id: `users-gp-in-${index}`,
            // value: `${a.companyname}-${index}`,
            Attached: {
              label: "Attach",
              cellStyle: {
                color: "text",
                fontWeight: "bold",
                maxWidth: "3rem",
              },
            },
            label: a.groupname,
            data: a,
          });
        });
      }
    } else {
      toaster.create({
        title: res?.message,
        type: "error",
      });
    }
    console.log("getGroupassociationList list", list);

    setGroupassociationList(list || []);
  };

  const onChangeAdminchargeDD = (data) => {
    setAdminchargeDD(data?.list ? [...data.list] : []);
    setAdminchargeItem(data?.item?.data);
  };

  const getChangeAdminchargeDD = (data) => {
    let index;
    let list;
    let item;

    list = constant.auAdminChargesDD?.map((a, inx) => ({
      key: `admincharge-${inx}`,
      value: `${a?.label}-${inx}`,
      label: `${a?.label}`,
      data: a,
    }));

    if ((data?.default || data?.default === 0) && list && list[0]) {
      list = list?.map((a, idx) => {
        if (a?.data?.id === data.default) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeAdminchargeDD({
      index,
      list,
      item,
    });
  };

  const getPermissionSt = async () => {
    setIsLoading(true);
    return api
      .getHaspermission({
        permvalue: [
          "perm_group_allocate",
          "perm_custom_pricing_allow",
          "perm_account_admin_change",
          "perm_commission_change",
          "perm_account_change_usertype",
          "perm_account_inactivate",
          // 'Allocate group',
          // 'Allow custom pricing',
          // 'Change administration charge',
          // 'Change commission',
          // 'change user type',
          // Inactivate
        ],
      })
      .then((res) => {
        console.log("getPermissionSt getHaspermission res", res);

        setIsLoading(false);
        if (res?.status === 200) {
          // res.data.perm_custom_pricing_allow = false;
          setPermissionSt(res?.data || {});
        } else {
          setPermissionSt({});
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  useEffect(() => {
    if (itemData?.appcode && itemData?.userid) {
      return;
    }
    if (phonemobile?.toString && phonemobile.toString()?.length > 6) {
      setAppcode(phonemobile.toString().slice(-7));
    } else {
      setAppcode("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phonemobile]);

  useEffect(() => {
    console.log("itemData", itemData);

    setDatejoined(itemData?.datejoined || "");
    // setUsertype(itemData?.usertype || "");
    setIsNewAdmin(itemData?.usertype === 1 ? true : false);
    setUsername(itemData?.username || "");
    setPassword(itemData?.password || "");
    setEmail(itemData?.email || "");
    setFirstname(itemData?.firstname || "");
    setLastname(itemData?.lastname || "");
    setAddress1(itemData?.address1 || "");
    setAddress2(itemData?.address2 || "");
    setAddress3(itemData?.address3 || "");
    setCounty(itemData?.county || "");
    setTown(itemData?.town || "");
    setPostcode(itemData?.postcode || "");
    setCountry(itemData?.country || "");
    setPhonelandline(itemData?.phonelandline || "");
    setPhonemobile(itemData?.phonemobile || "");
    setAppcode(itemData?.appcode || "");
    setBanksortcode(itemData?.banksortcode || "");
    setBankaccountnumber(itemData?.bankaccountnumber || "");
    setOpeningbalance(itemData?.openingbalance || "");
    setRefundafter(itemData?.refundafter || "");
    setSendagreementemail(itemData?.sendagreementemail || "");
    setUsecustomlogo(itemData?.usecustomlogo || "");
    setPricingall(itemData?.pricingall || false);
    setUsernotes(itemData?.usernotes || "");
    setActive(itemData?.active || "");
    setHide(itemData?.hide || "");
    setCompanyname(itemData?.companyname || "");

    setAdminChargeAmount(itemData?.admincostamt || "");
    setAdminChargePer(itemData?.admincostcent || "");

    setDefaultCommRuleAmount(itemData?.commissionamt || "");
    setDefaultCommRulePer(itemData?.commissioncent || "");

    getChangeAdminchargeDD({ default: itemData?.admincosttype });
    getGroupassociationList();
    getDefaultCommRuleDD({ default: itemData?.commissiontype });
    getDefaultCommRulePaidDD({ default: itemData?.commissionpaid });
    getPermissionDD({ default: itemData?.permissionid });
    getPermissionSt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={action === "useradd-edit" ? "User" : "New User"}
        isLoading={isLoading}
      />
      <Layout>
        <Flex justify={"end"} py={"1rem"} px={ismobile ? "0.3rem" : "2.5rem"}>
          <CheckboxComp
            onChange={onChangeIsNewAdmin}
            value={isNewAdmin}
            label={"Admin"}
          />
        </Flex>

        <SimpleGrid columns={ismobile ? 1 : 2} columnGap="1rem" rowGap="1rem">
          <InputComp
            type={"date"}
            label={"Joined"}
            value={datejoined}
            onChange={setDatejoined}
          />

          <InputComp
            label={"Company"}
            value={companyname}
            onChange={setCompanyname}
          />

          <InputComp
            label={"User Type"}
            items={permissionDD}
            onChange={(v) => onChangePermissionDD({ ...v, action: "byuser" })}
            disabled={isNewAdmin || !permissionSt.perm_account_change_usertype}
            type={"dropdown"}
          />

          <InputComp
            label={"Username"}
            value={username}
            onChange={setUsername}
          />

          <InputComp
            label={"Password"}
            type="password"
            value={password}
            onChange={setPassword}
          />

          <InputComp label={"Email"} value={email} onChange={setEmail} />

          <InputComp
            label={"First Name"}
            value={firstname}
            onChange={setFirstname}
          />

          <InputComp
            label={"Last Name"}
            value={lastname}
            onChange={setLastname}
          />
        </SimpleGrid>

        <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem" mt={"1rem"}>
          <InputComp
            label={"Address"}
            value={address1}
            onChange={setAddress1}
          />

          <InputComp label={" "} value={address2} onChange={setAddress2} />
          <InputComp label={" "} value={address3} onChange={setAddress3} />
          <Flex />
        </SimpleGrid>

        <SimpleGrid columns={ismobile ? 1 : 2} columnGap="1rem" rowGap="1rem">
          <InputComp label={"County"} value={county} onChange={setCounty} />

          <InputComp label={"Town"} value={town} onChange={setTown} />

          <InputComp
            label={"Postcode"}
            value={postcode}
            onChange={setPostcode}
          />

          <InputComp label={"Country"} value={country} onChange={setCountry} />

          <InputComp
            type={"number"}
            label={"Phone"}
            value={phonelandline}
            onChange={setPhonelandline}
          />

          <InputComp
            type={"number"}
            label={"Mobile"}
            value={phonemobile}
            onChange={setPhonemobile}
          />

          <InputComp
            type={"number"}
            label={"App Code (7 digits)"}
            value={appcode}
            onChange={setAppcode}
            required={true}
          />
        </SimpleGrid>

        {/* <SimpleGrid columns={1} columnGap="2rem" rowGap="2" mt={4} mb={4}></SimpleGrid> */}

        <Separator
          mt={"2rem"}
          w={"100%"}
          size={"md"}
          colorPalette={"fontdark"}
        />
        <SimpleGrid
          columns={1}
          columnGap="2rem"
          rowGap="2"
          mt={"2rem"}
          mb={"2rem"}
        >
          <Text fontWeight={"bold"}>Bank Details</Text>
        </SimpleGrid>

        <SimpleGrid columns={ismobile ? 1 : 2} columnGap="2rem" rowGap="1rem">
          <InputComp
            // type={"number"}
            label={"Sort Code"}
            value={banksortcode}
            onChange={setBanksortcode}
          />

          <InputComp
            type={"number"}
            label={"Account Number"}
            value={bankaccountnumber}
            onChange={setBankaccountnumber}
          />
        </SimpleGrid>

        <Separator
          w={"100%"}
          size={"md"}
          colorPalette={"fontdark"}
          mt={"2rem"}
          mb={"2rem"}
        />
        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="2rem"
          rowGap="1rem"
          // mt={'2rem'}
          // mb={"1rem"}
        >
          <Text fontWeight={"bold"}>AU Admin Charge</Text>
          <Flex />
          <InputComp
            label="Charge Type"
            type={"dropdown"}
            items={adminchargeDD}
            onChange={onChangeAdminchargeDD}
            disabled={!permissionSt.perm_account_admin_change}
          />

          {adminchargeItem?.id === 1 ? (
            <InputComp
              label={"Percent"}
              value={adminChargePer}
              onChange={setAdminChargePer}
              type={"number"}
              disabled={!permissionSt.perm_account_admin_change}
            />
          ) : null}

          {adminchargeItem?.id === 2 ? (
            <InputComp
              label={"Amount"}
              value={adminChargeAmount}
              onChange={setAdminChargeAmount}
              type={"number"}
              disabled={!permissionSt.perm_account_admin_change}
            />
          ) : null}

          <InputComp
            label={"Opening Balance"}
            value={openingbalance}
            onChange={setOpeningbalance}
            type={"number"}
            disabled={!permissionSt.perm_account_admin_change}
          />

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Opening Balance</Field.Label>
            <Input
              type="text"
              value={openingbalance}
              onChange={(e) => setOpeningbalance(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

          <InputComp
            label={"Required Balance"}
            value={refundafter}
            onChange={setRefundafter}
            type={"number"}
            disabled={!permissionSt.perm_account_admin_change}
          />
          {/* 
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Required Balance</Field.Label>
            <Input
              type="text"
              value={refundafter}
              onChange={(e) => setRefundafter(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        </SimpleGrid>

        <Separator
          w={"100%"}
          size={"md"}
          colorPalette={"fontdark"}
          mt={"2rem"}
          mb={"2rem"}
        />

        <Flex
          columns={ismobile ? 1 : 2}
          justify="space-between"
          alignItems={"center"}
        >
          <Text fontWeight={"bold"}>Associated Groups</Text>
          <Flex gap={"0.5rem"}>
            <ButtonComp label={"All"} onClick={onAssGroAll} />
            <ButtonComp label={"None"} onClick={onAssGroNon} />
          </Flex>

          {/* <InputComp type={"dropdown"} /> */}
        </Flex>

        <SimpleGrid
          columns={1}
          columnGap="2rem"
          rowGap="1rem"
          mt={"1rem"}
          mb={"1rem"}
        >
          <TableList
            type={"simple"}
            items={groupassociationList}
            headers={["Attached", "Group Name"]}
            h={"10rem"}
            onSelect={(v) => onGroupassociationSelc({ ...v, action: "byuser" })}
            selectedItem={groupassociationSelc}
          />
          <Text>
            Default commission rule applies to all clients under this user. To
            set up commission rules per client go to Manage - Commission Rules.
          </Text>
        </SimpleGrid>

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="2rem"
          rowGap="1rem"
          mt={"2rem"}
          mb={"1rem"}
        >
          <Text fontWeight={"bold"}>Default Commission Rule</Text>
          <Flex />
          <InputComp
            label={"Type"}
            type={"dropdown"}
            items={defaultCommRuleDD}
            onChange={onChangeDefaultCommRuleDD}
            disabled={!permissionSt.perm_commission_change}
          />

          {defaultCommRuleItem?.id === 1 || defaultCommRuleItem?.id === 2 ? (
            <>
              {defaultCommRuleItem?.id === 1 ? (
                <InputComp
                  label={"Percent"}
                  value={defaultCommRulePer}
                  onChange={setDefaultCommRulePer}
                  type={"number"}
                  disabled={!permissionSt.perm_commission_change}
                />
              ) : (
                <InputComp
                  label={"Amount"}
                  value={defaultCommRuleAmount}
                  onChange={setDefaultCommRuleAmount}
                  type={"number"}
                  disabled={!permissionSt.perm_commission_change}
                />
              )}

              <InputComp
                label={"Paid"}
                type={"dropdown"}
                items={defaultCommRulePaidDD}
                onChange={onChangeDefaultCommRulePaidDD}
                disabled={!permissionSt.perm_commission_change}
              />
            </>
          ) : null}

          <ToggleSwitch
            label={"Send E-Mail When Agreement Created"}
            value={sendagreementemail}
            onChange={setSendagreementemail}
          />
          <ToggleSwitch
            label={"Use Custom Logo"}
            value={usecustomlogo}
            onChange={setUsecustomlogo}
          />
          {/* <Checkbox>Send E-Mail When Agreement Created</Checkbox> */}
          {/* <Checkbox>Use Custom Logo</Checkbox> */}
        </SimpleGrid>

        <SimpleGrid
          columns={1}
          columnGap="2rem"
          rowGap="1rem"
          mt={"2rem"}
          mb={"1rem"}
        >
          <Text fontWeight={"bold"}>Show Pricing</Text>
        </SimpleGrid>

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="2rem"
          rowGap="1rem"
          // mt={"1rem"}
          mb={"1rem"}
        >
          <RadioInput
            items={[
              { label: "Standard and Exceptions", value: true },
              { label: "Exceptions Only", value: false },
            ]}
            value={pricingall}
            onChange={setPricingall}
            disabled={!permissionSt.perm_custom_pricing_allow}
          />
        </SimpleGrid>

        <SimpleGrid
          columns={1}
          columnGap="2rem"
          rowGap="1rem"
          mt={"1rem"}
          mb={"1rem"}
        >
          <Field.Root columns={1} orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Note</Field.Label>
            <Textarea
              value={usernotes}
              onChange={(e) => setUsernotes(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root>
        </SimpleGrid>

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="2rem"
          rowGap="1rem"
          mt={"1rem"}
          mb={"1rem"}
        >
          <Field.Root
            orientation="horizontal"
            justifyContent="flex-start"
            gap={"1rem"}
          >
            <Field.Label textStyle={fs}>Active</Field.Label>
            <RadioInput
              items={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              value={active}
              onChange={setActive}
              disabled={!permissionSt.perm_account_inactivate}

              // value={active === true ? 1 : 2}
              // onChange={(v) => setActive(v === 1 ? true : false)}
            />
          </Field.Root>
          <Field.Root
            orientation="horizontal"
            justifyContent="flex-start"
            gap={"1rem"}
          >
            <Field.Label textStyle={fs}>Hide</Field.Label>

            <RadioInput
              items={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              value={hide}
              onChange={setHide}
            />
          </Field.Root>
        </SimpleGrid>
      </Layout>
      <ButtonComp
        alignSelf={"flex-end"}
        mt={"2rem"}
        label={"Save"}
        onClick={onSubmit}
        keyname={"save"}
        disabled={isLoading}
      />
    </Flex>
  );
}

export default UserAdd;
